export default {
  quotationsFormatted(state) {
    return state.quotations.items || [];
  },
  quotationsCount(state) {
    const { total = null } = state.quotations;
    return total;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quotations/store/getters.js